class LeasingConfigurator {
  constructor() {
    // Add this at the beginning of the constructor
    if (this.checkFormSubmitted()) {
      this.showThankYouMessage();
      this.clearFormSubmissionState();
      return;
    }

    // Rest of your existing constructor code
    this.selectedProducts = [];
    this.selectedAddons = [];
    this.selectedServices = [];
    this.leasingPeriods = [
      parseInt(document.querySelector('.leasing-summary__info').dataset.leasingMonths) || 48
    ];
    const secondPeriodOption = document.querySelector('.leasing-period-option:nth-child(2)');
    if (secondPeriodOption) {
      this.leasingPeriods.push(parseInt(secondPeriodOption.dataset.period) || 36);
    }
    this.leasingMonths = this.leasingPeriods[0];
    this.initProductCards();
    this.initAddonCards();
    this.initServiceCards();
    this.initLeasingPeriodPicker();
    this.initQuantityControls();
    this.initContactLinks();
    this.updateAllPrices();
    this.updateSummary();
    this.lastToggleTime = 0;
    this.toggleDebounceTime = 300;
    this.form = document.getElementById('LeasingConfiguratorForm');
    this.initFormSubmission();
  }

  initProductCards() {
    const productCards = document.querySelectorAll('.leasing-product-card');
    productCards.forEach(card => {
      this.initProductCard(card);
    });
    this.initLoadMore();
  }

  initProductCard(card) {
    const selectButton = card.querySelector('.leasing-select-button');
    const quantityInput = card.querySelector('.leasing-quantity');
    const minusButton = card.querySelector('button[name="minus"]');
    const plusButton = card.querySelector('button[name="plus"]');

    if (selectButton) {
      selectButton.addEventListener('click', (e) => {
        e.preventDefault(); // Prevent any default behavior
        this.toggleProductSelection(card);
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', () => {
        this.updatePrice(card);
        if (card.classList.contains('selected')) {
          this.updateSelectedProduct(card);
        }
      });
    }

    if (minusButton) {
      minusButton.addEventListener('click', () => {
        if (quantityInput && quantityInput.value > quantityInput.min) {
          quantityInput.value = parseInt(quantityInput.value) - 1;
          quantityInput.dispatchEvent(new Event('change'));
        }
      });
    }

    if (plusButton) {
      plusButton.addEventListener('click', () => {
        if (quantityInput && quantityInput.value < quantityInput.max) {
          quantityInput.value = parseInt(quantityInput.value) + 1;
          quantityInput.dispatchEvent(new Event('change'));
        }
      });
    }

    this.updatePrice(card);
  }

  initAddonCards() {
    const addonCards = document.querySelectorAll('.leasing-configurator__addons .leasing-product-card');
    addonCards.forEach(card => {
      this.initProductCard(card);
      const selectButton = card.querySelector('.leasing-select-button');
      if (selectButton) {
        selectButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleAddonSelection(card);
        });
      }
    });
  }

  updateAddonSelection(card) {
    const addonId = card.dataset.productId;
    const name = card.querySelector('h3')?.textContent || 'Unknown Addon';
    const quantityInput = card.querySelector('.leasing-quantity');
    const monthlyPriceElement = card.querySelector('.leasing-rate');

    if (!quantityInput || !monthlyPriceElement) {
      console.error('Missing required elements for updating addon selection');
      return;
    }

    const quantity = parseInt(quantityInput.value);
    const monthlyPrice = parseFloat(monthlyPriceElement.textContent.replace('', '').replace('/month', '').trim());

    const existingAddonIndex = this.selectedAddons.findIndex(addon => addon.addonId === addonId);
    if (quantity > 0) {
      if (existingAddonIndex === -1) {
        this.selectedAddons.push({ addonId, name, quantity, monthlyPrice });
      } else {
        this.selectedAddons[existingAddonIndex] = { addonId, name, quantity, monthlyPrice };
      }
    } else {
      if (existingAddonIndex !== -1) {
        this.selectedAddons.splice(existingAddonIndex, 1);
      }
    }

    this.updateSummary();
  }

  toggleProductSelection(card) {
    const now = Date.now();
    if (now - this.lastToggleTime < this.toggleDebounceTime) {
      console.log('Debouncing toggle');
      return;
    }
    this.lastToggleTime = now;

    const productId = card.dataset.productId;
    const isSelected = card.classList.contains('selected');
    const selectButton = card.querySelector('.leasing-select-button');
    const quantityInput = card.querySelector('.leasing-quantity');
    const quantityButtons = card.querySelectorAll('.quantity__button');
    const productType = card.dataset.productType;

    console.log('Toggling product selection:', productId, 'Current state:', isSelected, 'Type:', productType);

    if (!isSelected) {
      console.log('Selecting product:', productId);
      card.classList.add('selected');
      if (selectButton) {
        selectButton.innerHTML = `
          <svg class="icon icon-checkmark" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
          </svg>
          Ausgewählt
        `;
      }
      if (quantityInput) quantityInput.disabled = true;
      if (quantityButtons) quantityButtons.forEach(button => button.disabled = true);
      card.style.pointerEvents = 'none';
      card.style.opacity = '0.7';
      if (productType === 'wandkasten') {
        this.addSelectedAddon(card);
      } else {
        this.addSelectedProduct(card);
      }
    } else {
      console.log('Unselecting product:', productId);
      if (productType === 'wandkasten') {
        this.removeSelectedAddon(productId);
      } else {
        this.unselectProduct(productId);
      }
    }
    this.updateSelectedServices();
    this.updateSummary();
    console.log('Updated selected products:', this.selectedProducts);
    console.log('Updated selected addons:', this.selectedAddons);
  }

  unselectProduct(productId) {
    console.log('Unselecting product:', productId);
    const card = document.querySelector(`.leasing-product-card[data-product-id="${productId}"]`);
    if (card) {
      card.classList.remove('selected');
      const selectButton = card.querySelector('.leasing-select-button');
      const quantityInput = card.querySelector('.leasing-quantity');
      const quantityButtons = card.querySelectorAll('.quantity__button');
      
      if (selectButton) selectButton.textContent = 'Auswählen';
      if (quantityInput) quantityInput.disabled = false;
      if (quantityButtons) quantityButtons.forEach(button => button.disabled = false);
      card.style.pointerEvents = 'auto';
      card.style.opacity = '1';
    }
    this.removeSelectedProduct(productId);
    // updateSelectedServices is called via removeSelectedProduct
    this.updateSummary();
  }

  addSelectedProduct(card) {
    const productId = card.dataset.productId;
    const name = card.querySelector('h3')?.textContent || 'Unknown Product';
    const quantityInput = card.querySelector('.leasing-quantity');
    const monthlyPriceElement = card.querySelector('.leasing-monthly-price');
    const type = card.dataset.productType || 'defibrillator';

    if (!quantityInput || !monthlyPriceElement) {
      console.error('Missing required elements for adding selected product');
      return;
    }

    const quantity = parseInt(quantityInput.value);
    const monthlyPrice = parseFloat(monthlyPriceElement.textContent.replace('€', '').replace('netto', '').trim());

    console.log('Adding selected product:', { productId, name, quantity, monthlyPrice, type });

    const existingProductIndex = this.selectedProducts.findIndex(product => product.productId === productId);
    if (existingProductIndex === -1) {
      this.selectedProducts.push({ productId, name, quantity, monthlyPrice, type });
    } else {
      this.selectedProducts[existingProductIndex] = { productId, name, quantity, monthlyPrice, type };
    }

    this.updateSummary();
  }

  removeSelectedProduct(productId) {
    console.log('Removing selected product:', productId);
    this.selectedProducts = this.selectedProducts.filter(product => product.productId !== productId);
    // Add this line to update services after product removal
    this.updateSelectedServices();
  }

  updateSelectedProduct(card) {
    const productId = card.dataset.productId;
    const quantity = parseInt(card.querySelector('.leasing-quantity').value);
    const monthlyPrice = parseFloat(card.querySelector('.leasing-monthly-price').textContent.replace('€', ''));

    const productIndex = this.selectedProducts.findIndex(product => product.productId === productId);
    if (productIndex !== -1) {
      this.selectedProducts[productIndex].quantity = quantity;
      this.selectedProducts[productIndex].monthlyPrice = monthlyPrice;
    }

    this.updateSummary();
  }

  updatePrice(card) {
    const productId = card.dataset.productId;
    const quantityInput = card.querySelector('.leasing-quantity');
    const quantity = parseInt(quantityInput.value);
    const pricesDataElement = document.getElementById(`product-${productId}-prices`);
    
    if (!pricesDataElement) {
        console.error(`Price data element not found for product ${productId}`);
        return;
    }
    
    const pricesData = JSON.parse(pricesDataElement.textContent);
    console.log(`Price data for product ${productId}:`, pricesData);
    
    const currentPeriod = this.leasingPeriods.length > 1 ? 
        (this.leasingMonths === this.leasingPeriods[0] ? 'period_1' : 'period_2') : 'period_1';
    const priceKey = `price_${quantity}_${currentPeriod}`;
    const defaultPriceKey = `default_price_${currentPeriod}`;
    
    let price = pricesData[priceKey] || pricesData[defaultPriceKey];

    if (price === undefined || price === null) {
        console.error(`Price not found for product ${productId}, quantity ${quantity}, period ${currentPeriod}`);
        console.log('Available price keys:', Object.keys(pricesData));
        return;
    }

    price = parseFloat(price);

    const monthlyPriceElement = card.querySelector('.leasing-monthly-price');
    const dailyPriceElement = card.querySelector('.leasing-daily-price');

    if (monthlyPriceElement) {
        monthlyPriceElement.textContent = `${price.toFixed(2)} €`;
    }

    if (dailyPriceElement) {
        const dailyPrice = price / 30;
        dailyPriceElement.textContent = `${dailyPrice.toFixed(2)} €`;
    }

    // Update the selected product/addon with the new price
    if (card.classList.contains('selected')) {
        const productType = card.dataset.productType;
        if (productType === 'wandkasten') {
            const addonIndex = this.selectedAddons.findIndex(addon => addon.productId === productId);
            if (addonIndex !== -1) {
                this.selectedAddons[addonIndex].monthlyPrice = price;
            }
        } else {
            const productIndex = this.selectedProducts.findIndex(product => product.productId === productId);
            if (productIndex !== -1) {
                this.selectedProducts[productIndex].monthlyPrice = price;
            }
        }
        this.updateSelectedProduct(card);
    }
}

  updateSummary() {
    const summaryContent = document.querySelector('.leasing-summary__content');
    if (!summaryContent) return;

    const existingEmptyState = summaryContent.querySelector('.leasing-summary__empty-state');
    let emptyState = existingEmptyState;
    
    // If empty state doesn't exist, create it
    if (!emptyState) {
      emptyState = document.createElement('div');
      emptyState.classList.add('leasing-summary__empty-state');
      emptyState.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="9" cy="21" r="1"></circle>
          <circle cx="20" cy="21" r="1"></circle>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
        </svg>
        <p>Noch keine Auswahl getroffen</p>
      `;
    }

    const infoSection = document.querySelector('.leasing-summary__info');
    const rateElement = infoSection.querySelector('.leasing-summary__rate');
    const schulungElement = infoSection.querySelector('.leasing-summary__schulung');
    const durationElement = infoSection.querySelector('.leasing-summary__duration');

    if (this.leasingMonths) {
      durationElement.style.display = 'flex';
      durationElement.querySelector('strong').textContent = `${this.leasingMonths} Monate`;
    } else {
      durationElement.style.display = 'none';
    }

    const totalPrice = this.calculateTotalPrice();
    const schulungTotal = this.calculateSchulungTotal();

    if (this.selectedProducts.length > 0 || this.selectedAddons.length > 0 || this.selectedServices.length > 0) {
      rateElement.style.display = 'flex';
      rateElement.querySelector('strong').textContent = `${totalPrice.toFixed(2)} € netto / Monat`;
      
      if (schulungTotal > 0) {
        schulungElement.style.display = 'flex';
        schulungElement.querySelector('strong').textContent = `${schulungTotal.toFixed(2)} € netto`;
      } else {
        schulungElement.style.display = 'none';
      }
    } else {
      rateElement.style.display = 'none';
      schulungElement.style.display = 'none';
    }

    const defibrillators = this.selectedProducts.filter(product => product.type === 'defibrillator');
    const wandkasten = this.selectedAddons;
    const regularServices = this.selectedServices.filter(s => !s.type?.includes('schulung'));
    const schulungen = this.selectedServices.filter(s => s.type?.includes('schulung'));

    // Clear previous content
    summaryContent.innerHTML = '';

    if (defibrillators.length > 0 || wandkasten.length > 0 || this.selectedServices.length > 0) {
      // Hide empty state
      emptyState.style.display = 'none';
      
      if (defibrillators.length > 0) {
        const title = defibrillators.length === 1 ? 'Ausgewählter Defibrillator' : 'Ausgewählte Defibrillatoren';
        const defibrillatorsSummary = document.createElement('div');
        defibrillatorsSummary.classList.add('leasing-summary__defibrillators');
        defibrillatorsSummary.innerHTML = `<h4 class="leasing-summary__category-title">${title}</h4>`;
        defibrillators.forEach(product => {
          const summaryItem = this.createSummaryItem(product);
          defibrillatorsSummary.appendChild(summaryItem);
        });
        summaryContent.appendChild(defibrillatorsSummary);
      }

      if (wandkasten.length > 0) {
        const title = wandkasten.length === 1 ? 'Ausgewählter Wandkasten' : 'Ausgewählte Wandkästen';
        const wandkastenSummary = document.createElement('div');
        wandkastenSummary.classList.add('leasing-summary__wandkasten');
        wandkastenSummary.innerHTML = `<h4 class="leasing-summary__category-title">${title}</h4>`;
        wandkasten.forEach(item => {
          const summaryItem = this.createSummaryItem(item);
          wandkastenSummary.appendChild(summaryItem);
        });
        summaryContent.appendChild(wandkastenSummary);
      }

      if (regularServices.length > 0) {
        const servicesTitle = regularServices.length === 1 ? 'Ausgewählte Zusatzleistung' : 'Ausgewählte Zusatzleistungen';
        const servicesSummary = document.createElement('div');
        servicesSummary.classList.add('leasing-summary__services');
        servicesSummary.innerHTML = `<h4 class="leasing-summary__category-title">${servicesTitle}</h4>`;
        regularServices.forEach(service => {
          const summaryItem = this.createServiceSummaryItem(service);
          servicesSummary.appendChild(summaryItem);
        });
        summaryContent.appendChild(servicesSummary);
      }

      if (schulungen.length > 0) {
        const schulungenTitle = schulungen.length === 1 ? 'Ausgewählte Schulung' : 'Ausgewählte Schulungen';
        const schulungenSummary = document.createElement('div');
        schulungenSummary.classList.add('leasing-summary__schulungen');
        schulungenSummary.innerHTML = `<h4 class="leasing-summary__category-title">${schulungenTitle}</h4>`;
        schulungen.forEach(schulung => {
          const summaryItem = this.createServiceSummaryItem(schulung);
          schulungenSummary.appendChild(summaryItem);
        });
        summaryContent.appendChild(schulungenSummary);
      }
    } else {
      // Show empty state
      emptyState.style.display = 'flex';
      summaryContent.appendChild(emptyState);
    }

    this.updateHiddenFields();
  }

  createSummaryItem(item) {
    const summaryItem = document.createElement('div');
    summaryItem.classList.add('summary-item');
    const quantity = item.quantity || 1;
    const isService = 'type' in item && item.type?.includes('schulung');
    const isPaidService = 'priceType' in item;
    const isWandkasten = item.type === 'wandkasten';
    
    let priceLabel;
    let priceValue;
    let quantityLabel = isWandkasten ? 'Wandkasten' : 'Gerät';

    if (isService) {
      priceLabel = 'einmalig';
      priceValue = item.price;
    } else if (isPaidService) {
      priceLabel = `/ Monat${item.quantity > 1 ? ` pro ${quantityLabel}` : ''}`;
      priceValue = item.price;
    } else {
      priceLabel = `/ Monat${quantity > 1 ? ` pro ${quantityLabel}` : ''}`;
      priceValue = item.monthlyPrice;
    }

    summaryItem.innerHTML = `
      <div class="summary-item__name">${item.name}</div>
      <div class="summary-item__details">
        Menge: ${quantity} | <strong>${priceValue.toFixed(2)} € netto ${priceLabel}</strong>
      </div>
      <button class="summary-item__remove" data-id="${item.productId || item.id}" data-type="${isWandkasten ? 'wandkasten' : 'product'}">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"></polyline>
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          <line x1="10" y1="11" x2="10" y2="17"></line>
          <line x1="14" y1="11" x2="14" y2="17"></line>
        </svg>
      </button>
    `;

    const removeButton = summaryItem.querySelector('.summary-item__remove');
    if (removeButton) {
      removeButton.addEventListener('click', () => {
        const type = removeButton.dataset.type;
        const id = removeButton.dataset.id;
        
        if (type === 'wandkasten') {
          this.removeSelectedAddon(id);
        } else {
          this.unselectProduct(id);
        }
      });
    }

    return summaryItem;
  }

  calculateTotalMonthlyRate() {
    let total = this.selectedProducts.reduce((sum, product) => sum + (product.monthlyPrice * product.quantity), 0);
    total += this.selectedAddons.reduce((sum, addon) => sum + (addon.monthlyPrice * addon.quantity), 0);

    this.selectedServices.forEach(service => {
      if (service.priceType === 'monthly') {
        total += service.price;
      } else {
        total += service.price / this.leasingMonths;
      }
    });

    return total;
  }

  initServiceCards() {
    const schulungCards = document.querySelectorAll('.leasing-service-schulung');
    schulungCards.forEach(card => {
      card.style.pointerEvents = 'auto';
      card.style.opacity = '1';
      const selectButton = card.querySelector('.schulung-select');
      selectButton.addEventListener('click', () => this.toggleSchulungSelection(card));
    });

    const paidOptionCheckboxes = document.querySelectorAll('.paid-option-checkbox');
    paidOptionCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => this.updateSelectedServices());
    });
  }

  toggleSchulungSelection(card) {
    const isSelected = card.classList.contains('selected');
    const schulungCards = document.querySelectorAll('.leasing-service-schulung');

    schulungCards.forEach(c => {
      c.classList.remove('selected');
      c.querySelector('.schulung-select').textContent = 'Auswählen';
      c.style.pointerEvents = 'auto';
      c.style.opacity = '1';
    });

    if (!isSelected) {
      card.classList.add('selected');
      const selectButton = card.querySelector('.schulung-select');
      selectButton.innerHTML = `
        <svg class="icon icon-checkmark" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
        </svg>
        Ausgewählt
      `;
      card.style.pointerEvents = 'none';
      card.style.opacity = '0.6';
    }

    this.updateSelectedServices();
    this.updateSummary();
  }

  updateSelectedServices() {
    this.selectedServices = [];
    const totalProductQuantity = this.calculateTotalProductQuantity();

    // Add paid services
    const paidServices = document.querySelectorAll('.leasing-service-paid-option input:checked');
    paidServices.forEach(service => {
      const serviceCard = service.closest('.leasing-service-paid-option');
      const pricesData = JSON.parse(document.getElementById(`service-${service.value}-prices`).textContent);
      const currentPeriod = this.leasingPeriods.length > 1 ? 
        (this.leasingMonths === this.leasingPeriods[0] ? 'price_period_1' : 'price_period_2') : 'price_period_1';
      const price = parseFloat(pricesData[currentPeriod]);
      const quantity = pricesData.quantity_matches_products ? totalProductQuantity : 1;

      this.selectedServices.push({
        id: service.value,
        name: serviceCard.querySelector('h4').textContent,
        price: price,
        priceType: pricesData.price_type,
        type: 'paid_option',
        quantity: quantity
      });
    });

    // Add selected schulung
    const selectedSchulung = document.querySelector('.leasing-service-schulung.selected');
    if (selectedSchulung) {
      const pricesData = JSON.parse(document.getElementById(`service-${selectedSchulung.dataset.serviceId}-prices`).textContent);
      const currentPeriod = this.leasingPeriods.length > 1 ? (this.leasingMonths === this.leasingPeriods[0] ? 'price_period_1' : 'price_period_2') : 'price_period_1';
      const price = parseFloat(pricesData[currentPeriod]);

      this.selectedServices.push({
        id: selectedSchulung.dataset.serviceId,
        name: selectedSchulung.querySelector('h3').textContent,
        price: price,
        priceType: pricesData.price_type,
        type: 'schulung'
      });
    }

    this.updateSummary();
  }

  createServiceSummaryItem(service) {
    const summaryItem = document.createElement('div');
    summaryItem.classList.add('summary-item');
    const isSchulungService = service.type?.includes('schulung');
    const quantity = service.quantity || 1;
    
    summaryItem.innerHTML = `
      <div class="summary-item__name">${service.name}</div>
      <div class="summary-item__details">
        ${quantity > 1 ? `Menge: ${quantity} | ` : ''}
        <strong>${service.price.toFixed(2)} € netto${isSchulungService ? ' einmalig' : 
          (service.priceType === 'monthly' ? ` / Monat${quantity > 1 ? ' pro Gerät' : ''}` : ' einmalig')}</strong>
      </div>
      <button class="summary-item__remove" data-id="${service.id}" data-type="${isSchulungService ? 'schulung' : 'service'}">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"></polyline>
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          <line x1="10" y1="11" x2="10" y2="17"></line>
          <line x1="14" y1="11" x2="14" y2="17"></line>
        </svg>
      </button>
    `;

    const removeButton = summaryItem.querySelector('.summary-item__remove');
    if (removeButton) {
      removeButton.addEventListener('click', () => {
        const serviceType = removeButton.dataset.type;
        const serviceId = removeButton.dataset.id;
        
        if (serviceType === 'schulung') {
          this.removeSelectedSchulung();
        } else {
          this.removeSelectedPaidService(serviceId);
        }
      });
    }

    return summaryItem;
  }

  toggleAddonSelection(card) {
    const addonId = card.dataset.productId;
    const isSelected = card.classList.contains('selected');
    const selectButton = card.querySelector('.leasing-select-button');
    const quantityInput = card.querySelector('.leasing-quantity');
    const quantityButtons = card.querySelectorAll('.quantity__button');

    console.log('Toggling addon selection:', addonId, 'Current state:', isSelected);

    if (!isSelected) {
      console.log('Selecting addon:', addonId);
      card.classList.add('selected');
      if (selectButton) {
        selectButton.innerHTML = `
          <svg class="icon icon-checkmark" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
          </svg>
          Ausgewählt
        `;
      }
      if (quantityInput) quantityInput.disabled = true;
      if (quantityButtons) quantityButtons.forEach(button => button.disabled = true);
      card.style.pointerEvents = 'none';
      card.style.opacity = '0.6';
      this.addSelectedAddon(card);
    } else {
      console.log('Unselecting addon:', addonId);
      this.removeSelectedAddon(addonId);
    }

    this.updateSummary();
    console.log('Updated selected addons:', this.selectedAddons);
  }

  addSelectedAddon(card) {
    const addonId = card.dataset.productId;
    const name = card.querySelector('h3')?.textContent || 'Unknown Addon';
    const quantityInput = card.querySelector('.leasing-quantity');
    const monthlyPriceElement = card.querySelector('.leasing-monthly-price');

    if (!quantityInput || !monthlyPriceElement) {
      console.error('Missing required elements for adding selected addon');
      return;
    }

    const quantity = parseInt(quantityInput.value);
    const monthlyPrice = parseFloat(monthlyPriceElement.textContent.replace('€', '').trim());

    console.log('Adding selected addon:', { addonId, name, quantity, monthlyPrice, type: 'wandkasten' });

    const existingAddonIndex = this.selectedAddons.findIndex(addon => addon.productId === addonId);
    if (existingAddonIndex === -1) {
      this.selectedAddons.push({ productId: addonId, name, quantity, monthlyPrice, type: 'wandkasten' });
    } else {
      this.selectedAddons[existingAddonIndex] = { productId: addonId, name, quantity, monthlyPrice, type: 'wandkasten' };
    }
  }

  removeSelectedAddon(addonId) {
    console.log('Removing selected addon:', addonId);
    const card = document.querySelector(`.leasing-product-card[data-product-id="${addonId}"]`);
    if (card) {
      card.classList.remove('selected');
      const selectButton = card.querySelector('.leasing-select-button');
      const quantityInput = card.querySelector('.leasing-quantity');
      const quantityButtons = card.querySelectorAll('.quantity__button');
      
      if (selectButton) {
        selectButton.textContent = 'Auswählen';
      }
      if (quantityInput) {
        quantityInput.disabled = false;
      }
      if (quantityButtons) {
        quantityButtons.forEach(button => button.disabled = false);
      }
      card.style.pointerEvents = 'auto';
      card.style.opacity = '1';
    }
    this.selectedAddons = this.selectedAddons.filter(addon => addon.productId !== addonId);
    console.log('Updated selected addons after removal:', this.selectedAddons);
    this.updateSummary();
  }

  removeSelectedPaidService(serviceId) {
    const checkbox = document.querySelector(`.leasing-service-paid-option input[value="${serviceId}"]`);
    if (checkbox) {
      checkbox.checked = false;
    }
    this.selectedServices = this.selectedServices.filter(service => service.id !== serviceId);
    this.updateSummary();
  }

  removeSelectedSchulung() {
    const selectedSchulung = document.querySelector('.leasing-service-schulung.selected');
    if (selectedSchulung) {
      selectedSchulung.classList.remove('selected');
      const selectButton = selectedSchulung.querySelector('.schulung-select');
      if (selectButton) {
        selectButton.textContent = 'Auswählen';
      }
      selectedSchulung.style.pointerEvents = 'auto';
      selectedSchulung.style.opacity = '1';
    }
    this.selectedServices = this.selectedServices.filter(service => service.type !== 'schulung');
    this.updateSummary();
  }

  updateHiddenFields() {
    document.getElementById('leasing-period-summary').value = `${this.leasingMonths} Monate`;
    document.getElementById('total-price-summary').value = `${this.calculateTotalPrice().toFixed(2)} € netto / Monat`;
    document.getElementById('products-summary').value = this.selectedProducts.map(p => 
      `${p.name} (Menge: ${p.quantity}, Preis: ${p.monthlyPrice.toFixed(2)} € / Monat)`
    ).join('\n');
    document.getElementById('addons-summary').value = this.selectedAddons.map(a => 
      `${a.name} (Menge: ${a.quantity}, Preis: ${a.monthlyPrice.toFixed(2)} € / Monat)`
    ).join('\n');
    document.getElementById('services-summary').value = this.selectedServices
      .filter(s => !s.type?.includes('schulung'))
      .map(s => `${s.name} (Preis: ${s.price.toFixed(2)} € netto${s.priceType === 'monthly' ? ' / Monat' : ' einmalig'})`)
      .join('\n');
    document.getElementById('schulung-summary').value = this.selectedServices
      .filter(s => s.type?.includes('schulung'))
      .map(s => `${s.name} (Preis: ${s.price.toFixed(2)} € netto einmalig)`)
      .join('\n');
  }

  calculateTotalPrice() {
    const productTotal = this.selectedProducts.reduce((sum, p) => sum + p.monthlyPrice * p.quantity, 0);
    const addonTotal = this.selectedAddons.reduce((sum, a) => sum + a.monthlyPrice * a.quantity, 0);
    const serviceTotal = this.selectedServices
      .filter(s => !s.type?.includes('schulung'))
      .reduce((sum, s) => {
        const quantity = s.quantity || 1;
        return sum + (s.priceType === 'monthly' ? s.price * quantity : s.price / this.leasingMonths);
      }, 0);
    return productTotal + addonTotal + serviceTotal;
  }

  initFormSubmission() {
    if (this.form) {
      this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
    }
  }

  handleFormSubmit(event) {
    event.preventDefault();
    this.updateHiddenFields();

    // Set localStorage flag
    localStorage.setItem('leasingFormSubmitted', 'true');
    
    // Set cookie with 5-minute expiration
    const expirationDate = new Date();
    expirationDate.setMinutes(expirationDate.getMinutes() + 5);
    document.cookie = `leasingFormSubmitted=true; expires=${expirationDate.toUTCString()}; path=/`;

    const formData = new FormData(this.form);
    fetch(window.Shopify.routes.root + 'contact', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    });

    // Let the form submit naturally to handle Shopify's redirect
  }

  initLeasingPeriodPicker() {
    const periodOptions = document.querySelectorAll('.leasing-period-option');
    periodOptions.forEach((option, index) => {
      const selectButton = option.querySelector('.period-select');
      selectButton.addEventListener('click', () => this.selectLeasingPeriod(option));
    });
    // The first option is always selected by default
    this.leasingMonths = parseInt(periodOptions[0].dataset.period);
    this.updateAllPrices();
    this.updateSummary();
  }

  selectLeasingPeriod(selectedOption) {
    const options = document.querySelectorAll('.leasing-period-option');
    options.forEach(option => {
      option.classList.remove('selected');
      option.style.pointerEvents = 'auto';
      option.style.opacity = '1';
      const button = option.querySelector('.period-select');
      button.textContent = 'Auswählen';
      button.classList.remove('selected');
    });

    selectedOption.classList.add('selected');
    selectedOption.style.pointerEvents = 'none';
    selectedOption.style.opacity = '0.6';
    const button = selectedOption.querySelector('.period-select');
    button.innerHTML = `
      <svg class="icon icon-checkmark" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
      </svg>
      Ausgewählt
    `;
    button.classList.add('selected');

    // Update leasing months
    this.leasingMonths = parseInt(selectedOption.dataset.period);

    // Update all prices in the UI first
    this.updateAllPrices();
    
    // Then update the selected items' prices in the data structures
    const selectedProductCards = document.querySelectorAll('.leasing-product-card.selected');
    selectedProductCards.forEach(card => {
      const productId = card.dataset.productId;
      const quantity = parseInt(card.querySelector('.leasing-quantity').value);
      const monthlyPrice = parseFloat(card.querySelector('.leasing-monthly-price').textContent.replace('€', '').replace('netto', '').trim());
      
      if (card.dataset.productType === 'wandkasten') {
        const addonIndex = this.selectedAddons.findIndex(addon => addon.productId === productId);
        if (addonIndex !== -1) {
          this.selectedAddons[addonIndex].monthlyPrice = monthlyPrice;
        }
      } else {
        const productIndex = this.selectedProducts.findIndex(product => product.productId === productId);
        if (productIndex !== -1) {
          this.selectedProducts[productIndex].monthlyPrice = monthlyPrice;
        }
      }
    });

    // Update service prices
    this.updateServicePrices();
    this.updateSelectedServices();
    
    // Update summary
    this.updateSummary();

    // Update duration display
    const durationElement = document.querySelector('.leasing-summary__duration strong');
    if (durationElement) {
      durationElement.textContent = `${this.leasingMonths} Monate`;
      durationElement.parentElement.style.display = 'flex';
    }
  }

  updateAllPrices() {
    const allCards = document.querySelectorAll('.leasing-product-card');
    allCards.forEach(card => this.updatePrice(card));
    this.updateServicePrices();
  }

  updateServicePrices() {
    const serviceElements = document.querySelectorAll('.leasing-service-paid-option, .leasing-service-schulung');
    serviceElements.forEach(serviceElement => {
      const serviceId = serviceElement.dataset.serviceId;
      if (!serviceId) {
        console.error('Service element does not have a serviceId:', serviceElement);
        return;
      }

      const pricesDataElement = document.getElementById(`service-${serviceId}-prices`);
      if (!pricesDataElement) {
        console.error(`Price data element not found for service ${serviceId}`);
        return;
      }
      
      const pricesData = JSON.parse(pricesDataElement.textContent);
      const isSchulungService = pricesData.service_type?.includes('schulung');
      const currentPeriod = this.leasingMonths === this.leasingPeriods[0] ? 'price_period_1' : 'price_period_2';
      let price = parseFloat(pricesData[currentPeriod]);

      if (isNaN(price)) {
        console.error(`Invalid price for service ${serviceId}, period ${currentPeriod}`);
        return;
      }

      const priceElement = serviceElement.querySelector('.paid-option-price');
      if (priceElement) {
        if (isSchulungService) {
          priceElement.textContent = `${price.toFixed(2)} € netto einmalig`;
        } else {
          const priceType = pricesData.price_type;
          const matchesQuantity = pricesData.quantity_matches_products;
          priceElement.textContent = `${price.toFixed(2)} € netto ${priceType === 'monthly' ? '/ Monat' : 'einmalig'}${matchesQuantity ? ' pro Gerät' : ''}`;
        }
      }
    });
  }

  initQuantityControls() {
    const quantitySelects = document.querySelectorAll('.leasing-quantity');
    quantitySelects.forEach(select => {
      select.addEventListener('change', (e) => {
        this.updatePrice(e.target.closest('.leasing-product-card'));
      });
    });
  }

  updateProductPrice(product) {
    const card = document.querySelector(`.leasing-product-card[data-product-id="${product.productId}"]`);
    if (card) {
      this.updatePrice(card);
    }
  }

  updateAddonPrice(addon) {
    const card = document.querySelector(`.leasing-product-card[data-product-id="${addon.addonId}"]`);
    if (card) {
      this.updatePrice(card);
    }
  }

  updateServicePrice(service) {
    const serviceElement = document.querySelector(`.leasing-service-paid-option[data-service-id="${service.id}"]`);
    if (serviceElement) {
      const priceElement = serviceElement.querySelector('.paid-option-price');
      if (priceElement) {
        const price = this.leasingMonths === this.leasingPeriods[0] ? service.price : service.price2;
        priceElement.textContent = `+${(price).toFixed(2)} € netto ${service.priceType === 'monthly' ? '/ Monat' : 'einmalig'}`;
      }
    }
  }

  initContactLinks() {
    const contactLinks = document.querySelectorAll('.leasing-contact-link');
    contactLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.openShopifyChat();
      });
    });
  }

  openShopifyChat() {
    const chatWidget = document.getElementById('ShopifyChat');
    if (chatWidget && chatWidget.shadowRoot) {
      const chatButton = chatWidget.shadowRoot.querySelector('.chat-app > button');
      if (chatButton) {
        chatButton.click();
      } else {
        console.error('Chat button not found within ShopifyChat widget');
      }
    } else {
      console.error('ShopifyChat widget or its shadow root not found');
    }
  }

  checkFormSubmitted() {
    const localStorageSubmitted = localStorage.getItem('leasingFormSubmitted') === 'true';
    const cookieSubmitted = document.cookie.split(';').some(item => item.trim().startsWith('leasingFormSubmitted='));
    return localStorageSubmitted && cookieSubmitted;
  }

  clearFormSubmissionState() {
    localStorage.removeItem('leasingFormSubmitted');
    document.cookie = 'leasingFormSubmitted=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }

  showThankYouMessage() {
    const mainContainer = document.querySelector('.leasing-configurator__main');
    const summaryContainer = document.querySelector('.leasing-configurator__summary');
    const thankYouWrapper = document.querySelector('.leasing-configurator__thank-you');
    
    if (mainContainer && summaryContainer && thankYouWrapper) {
      mainContainer.style.display = 'none';
      summaryContainer.style.display = 'none';
      thankYouWrapper.style.display = 'flex';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  updateSchulungPrice(serviceElement) {
    const serviceId = serviceElement.dataset.serviceId;
    const pricesDataElement = document.getElementById(`service-${serviceId}-prices`);
    
    if (!pricesDataElement) {
      console.error(`Price data element not found for service ${serviceId}`);
      return;
    }
    
    const pricesData = JSON.parse(pricesDataElement.textContent);
    const price = parseFloat(pricesData.price_period_1);

    const priceElement = serviceElement.querySelector('.schulung-price');
    if (priceElement) {
      priceElement.textContent = `${price.toFixed(2)} € netto einmalig`;
    }
  }

  calculateSchulungTotal() {
    return this.selectedServices
      .filter(s => s.type?.includes('schulung'))
      .reduce((sum, s) => sum + s.price, 0);
  }

  calculateTotalProductQuantity() {
    return this.selectedProducts.reduce((sum, product) => sum + product.quantity, 0);
  }

  initLoadMore() {
    const loadMoreButton = document.querySelector('.leasing-load-more-button');
    if (!loadMoreButton) return;

    loadMoreButton.addEventListener('click', () => {
      const container = document.querySelector('.leasing-product-grid__items');
      const productsPerLoad = parseInt(container.dataset.productsPerLoad);
      const totalProducts = parseInt(container.dataset.totalProducts);
      const visibleProducts = document.querySelectorAll('.leasing-product-card:not(.hidden)').length;
      
      const hiddenProducts = document.querySelectorAll('.leasing-product-card.hidden');
      let productsToShow = 0;

      hiddenProducts.forEach((product, index) => {
        if (index < productsPerLoad) {
          product.classList.remove('hidden');
          productsToShow++;
        }
      });

      if (visibleProducts + productsToShow >= totalProducts) {
        document.querySelector('.leasing-load-more').style.display = 'none';
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.leasingConfigurator = new LeasingConfigurator();
});
